<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Listagem das Categorias de Tarifas.</span>
                <br />
                <span class="navigation">Cadastros > Categoria Tarifas</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 mb-2">
              <label for="filtro">Filtro:</label>
              <span class="p-fluid">
                <InputText type="text" id="filtro" v-model="filtro" />
              </span>
            </div>
            <div class="mb-2">
              <label for="btnSearch">&nbsp;</label>
              <span class="p-fluid">
                <Button label="Pesquisar" title="Pesquisar" icon="pi pi-search" :disabled="search"
                  @click="pesquisar()" />
              </span>
            </div>
            <div class="mb-2" style="padding-left:2px">
              <label for="btnSearch">&nbsp;</label>
              <span class="p-fluid">
                <Button label="Limpar" title="Limpar" icon="pi pi-trash" :disabled="search" @click="clear()" />
              </span>
            </div>
          </div>
          <div class="row">
            <DataTable :value="catTarifaList" :paginator="true" :rows="10" class="p-datatable-responsive"
              :autoLayout="true">
              <Column headerStyle="width: 8em" bodyStyle="text-align: center">
                <template #body="slotProps">
                  <Button type="button" icon="pi pi-pencil" style="margin-right: .5em"
                    @click="detail(slotProps.data.id)"></Button>
                  <Button type="button" title="Ativar" icon="pi pi-check" @click="confirmAtivar(slotProps.data.id)"
                    v-if="slotProps.data.dataVigenciaFinal"></Button>
                  <Button type="button" title="Inativar" class="p-button-danger" icon="pi pi-times"
                    @click="confirmInativar(slotProps.data.id)" v-if="!slotProps.data.dataVigenciaFinal"></Button>
                </template>
              </Column>
              <Column headerStyle="width: 10%" header="Status">
                <template #body="slotProps">

                  {{ getStatus(slotProps.data.vigenciaFinalFormatada) }}

                </template>
              </Column>
              <Column field="nome" header="Nome"></Column>

            </DataTable>
          </div>
          <hr />

          <div class="row">
            <span class="p-fluid mr-2">
              <router-link to="/categoriaTarifaCadastro">
                <Button type="button" icon="pi pi-plus" label="Novo" title="Novo" />
              </router-link>
            </span>
          </div>
        </div>
      </div>
    </div>
    <Dialog header="Aviso" :visible.sync="display" :style="{ width: '30vw' }" :contentStyle="{ overflow: 'visible' }"  :modal="true">
      Confirma a {{ this.situacao === 'A' ? 'ativação' : 'Inativação' }} do Registro?
      <div class="card-body">
        <div class="row" v-if="this.situacao != 'A'">
          <div class="col-md-5 mb-2">
            <label>Data Vigencia Final: *</label>
            <span class="p-fluid">
              <Calendar id="dataFinal" name="dataFinal"  :showIcon="true" v-model="dataInativacao"
                dateFormat="dd/mm/yy" />
            </span>
          </div>
        </div>
      </div>
      <template #footer>
        <Button label="Sim" icon="pi pi-check" @click="atualizarStatus" title="Sim" />
        <Button label="Não" icon="pi pi-times" @click="close" title="Não" class="p-button-secondary" />
      </template>
    </Dialog>
  </div>
</template>
<script>
import LoginService from "../services/acesso/login.service";
import CategoriaTarifaService from '../services/nfse/categoria.tarifa.service';

export default {
  name: "categoriaTarifa",
  data() {
    return {
      loading: false,
      display: false,
      search: false,
      currentUser: null,
      filtro: "",
      catTarifaList: [],
      catTarifaId: null,
      situacao: null,
      dataInativacao: null
    };
  },
  created() {
    this.currentUser = LoginService.currentUserValue;
    this.pesquisar();
  },
  methods: {
    clear() {
      this.filtro = "";
      this.pesquisar();
    },
    pesquisar() {
      this.search = true;
      CategoriaTarifaService.findAllPedagioByFiltro(
        this.currentUser.usuario.idCliente,
        this.filtro
      ).then(
        Categoria => {
          this.catTarifaList = Categoria.data;
        },
        error => {
          let errorMessage = "Houve um problema listar as Categorias!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
      this.search = false;
    },
    detail(CatTarifaId) {
      this.$router.push({ name: "categoriaTarifaCadastro", params: { id: CatTarifaId } });
    },
    confirmInativar(catTarifaId) {
      this.situacao = 'I';
      this.catTarifaId = catTarifaId;
      this.display = true;
    },
    confirmAtivar(catTarifaId) {
      this.situacao = 'A';
      this.catTarifaId = catTarifaId;
      this.display = true;
    },
    close() {
      this.catTarifaId = null;
      this.display = false;
    },
    atualizarStatus() {
      if (this.situacao == 'A') {
        CategoriaTarifaService.ativarPedagio(this.catTarifaId).then(
          data => {
            console.log(data);
            this.$toast.add({
              severity: "success",
              summary: "Categoria ativada com sucesso"
            });
            setTimeout(async () => {
              await this.pesquisar();
              this.display = false;
            }, 250);
          },
          error => {
            let errorMessage = "Houve um problema ao ativar a Categoria!";
            if (error.response) {
              errorMessage = error.response.data;
            }
            this.$toast.add({
              severity: "error",
              summary: errorMessage
            });
          }
        );
      } else {
        if (!this.dataInativacao) {
          this.$toast.add({
            severity: "warn",
            summary: "Informe a data de inativação!"
          });
          return;
        }
        CategoriaTarifaService.inativarPedagio(this.PedagioId, this.dataInativacao).then(
          data => {
            console.log(data);
            this.$toast.add({
              severity: "success",
              summary: "Pegágio inativado com sucesso"
            });
            setTimeout(async () => {
              await this.pesquisar();
              this.display = false;
            }, 250);
          },
          error => {
            let errorMessage = "Houve um problema ao inativar o Pedágio!";
            if (error.response) {
              errorMessage = error.response.data;
            }
            this.$toast.add({
              severity: "error",
              summary: errorMessage
            });
          }
        );
      }
    },
    getStatus(data) {
      if (!data) {
        return 'Ativo';
      } else {
        const partes = data.split('/');
        const date = new Date(`${partes[2]}-${partes[1]}-${partes[0]}T23:59:59`);
        const hoje = new Date();

        if (date < hoje) {
          return 'Inativo';
        }
        return 'Ativo';
      }
    },

    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    }
  }
};
</script>

<style scoped></style>